import type { DistributiveOmit } from '@_/types';
import type { I18nTextInputProps, I18nTextInputValue } from '../I18nTextInput/index.ts';
import type { FormComponentProps } from './types.ts';
import { I18nTextInput } from '../I18nTextInput/index.ts';
import { useFieldContext } from './BaseForm.ts';
import { usePropsFromField } from './utils.ts';

export function FormI18nTextInput(
  props: FormComponentProps<DistributiveOmit<I18nTextInputProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<I18nTextInputValue>();

  const formProps = {
    ...usePropsFromField(props, field),
    onBlur: field.handleBlur,
    onChange: field.handleChange,
    value: field.state.value
  } as I18nTextInputProps;

  return <I18nTextInput key={field.name} {...formProps} />;
}
